import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";
import {Article} from "../domain/article";
import {environment} from "../../environments/environment";
import {APP_CODE_CONTEXTUAL, ARTICLE_URI} from "./shared-data.service";

@Injectable()
export class ArticleService {

  constructor( private http: HttpClient) { }

  getArticle(reference: string): Observable<Article>{

    const article  = {
      appCode : APP_CODE_CONTEXTUAL,
      locCode : 'en_GB',
      reference: reference
    }

    return this.http.post<Article>(environment.apiConfig.uri + ARTICLE_URI,
      article)
  }
}
